import React from "react"

function Header(){
    return <nav className="header-main">
        <div className="header-wrapper">
            <ul className="header-span">
                <span></span>
            </ul>
        </div>
    </nav>
}

export {Header}